import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface CardHeaderUniDriver extends BaseUniDriver {
  title(): Promise<string>;
  subtitle(): Promise<string>;
}
